import { createFcmDetails } from '../shared/factory';

export const FCM_DETAILS_DM_ABOUT_PAGE = createFcmDetails('dm_about_page', {
	owner: 'Campaign Squad',
	context: 'General DM landing page at /decision-makers',
	description: 'Set true to enable page',
	import: false,
});
